import { isPseudoLocale, toCortexLocale } from './pseudo_locale.helpers';
const isSupported = (siteLocales, locale) => !!locale && siteLocales.some((supported) => toCortexLocale(supported) === toCortexLocale(locale));
/**
 * Pure resolver for the study-scoped site locale. Precedence: a study that supports a single real
 * locale auto-selects it; otherwise a supported stored site locale wins (an unsupported stored value
 * is cleared and the picker opens), then the Axon account locale, then the global shell/profile locale, and
 * finally the picker. Pseudo locales are only ever candidates when present in `siteLocales`, which
 * the caller populates only in pseudo-enabled environments.
 */
export const resolveStudyLocale = ({ siteLocales, storedLocale, axonLocale, rootLocale, }) => {
    const realSiteLocales = siteLocales.filter((locale) => !isPseudoLocale(locale));
    if (realSiteLocales.length === 1) {
        return { action: 'use', locale: realSiteLocales[0] };
    }
    if (storedLocale) {
        return isSupported(siteLocales, storedLocale)
            ? { action: 'use', locale: storedLocale }
            : { action: 'clear-and-prompt' };
    }
    if (isSupported(siteLocales, axonLocale)) {
        return { action: 'use', locale: axonLocale };
    }
    if (isSupported(siteLocales, rootLocale)) {
        return { action: 'use', locale: rootLocale };
    }
    return { action: 'prompt' };
};
